<template>
  <HeadlineComponent>Neues Team anlegen</HeadlineComponent>
  <div v-if="!event.id">Es muss eie Veranstaltung ausgewählt sein.</div>
  <Form
    v-if="event.id"
    class="form-horizontal"
    @submit="create"
    :initialValues="{ start_date: event.start_date }"
  >
    <TeamForm />
    <LoadingButton class="btn-primary" :loading="loading"
      >Anlegen</LoadingButton
    >
  </Form>
</template>

<script>
import teamService from "@/services/team.service.js";
import eventService from "@/services/event.service.js";
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import TeamForm from "@/components/TeamForm.vue";
import moment from "moment";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import { Form } from "vee-validate";
import LoadingButton from "@/components/LoadingButton.vue";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default {
  name: "CreateTeamView",

  components: {
    TeamForm,
    HeadlineComponent,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      event: {},
    };
  },
  async beforeRouteEnter(to, from, next) {
    let event = {};
    try {
      let response = await eventService.get(to.params.event);
      event = response.data;
      event.start_date = moment(event.start_date).format("YYYY-MM-DDTHH:mm");
    } catch (e) {
      if (e) {
        console.log(e);
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    next((vm) => {
      vm.event = event;
    });
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async create(data, actions) {
      this.loading = true;
      console.log(data);
      let team = {
        name: data.name,
        description: data.description,
        start_date: moment(data.start_date, "YYYY-MM-DDTHH:mm").format(),
        teamleads: data.teamleads,
      };
      try {
        await teamService.create(this.$route.params.event, team);
        this.addAlert("success", "Das Team wurde erfolgreich angelegt");
        this.$router.push({
          path: "/teams",
          query: { event_id: this.$route.params.event },
        });
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
            this.loading = false;
            return;
          }
          console.log(e);
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
